import { useContext } from "react";
import { ProcessTrackerContext } from "@/providers/ProcessTrackerProvider";
import type { ProcessTrackerContextValue } from "@/providers/ProcessTrackerProvider";

export default function useProcessTracker(): ProcessTrackerContextValue {
  const context = useContext(ProcessTrackerContext);
  if (!context) {
    throw new Error("useProcessTracker must be used within a ProcessTrackerProvider");
  }
  return context;
}
